export default __webpack_public_path__ + "cbd22de8819406be321c6c9239c2f979.png";